// material-ui
import { Skeleton } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';

const ShimmerCard = () => {
    const theme = useTheme();

    return <Skeleton sx={{ bgcolor: theme.palette.primary[200], borderRadius: '12px' }} variant="rectangular" width="100%" height={130} />;
};

export default ShimmerCard;
